import { render, staticRenderFns } from "./CollectionShow.vue?vue&type=template&id=304d01c0&scoped=true&"
import script from "./CollectionShow.vue?vue&type=script&lang=js&"
export * from "./CollectionShow.vue?vue&type=script&lang=js&"
import style0 from "./CollectionShow.vue?vue&type=style&index=0&id=304d01c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d01c0",
  null
  
)

export default component.exports